import { useState } from "react";
import styled, { css, keyframes } from "styled-components";
import { PALETTE } from "../../styles/palette";
import { Input } from "../input";

const StyledHeader = styled.header`
  width: 100%;
  height: 44px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const StyledLocation = styled.h3`
  font-size: 1.25rem;
  position: absolute;
  top: 22px;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const inputColorChange = keyframes`
 100% { width: 91vw; height: 100%; padding: 9px 8px; background-color: ${PALETTE.WHITE}; }
`;

const StyledInputContainer = styled.button<{ isOpen: boolean }>`
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  z-index: 1;
  animation: ${(props) =>
    props.isOpen
      ? css`
          ${inputColorChange} .5s forwards
        `
      : ""};
`;

type HeaderProps = {
  location: string;
};

export const Header = ({ location }: HeaderProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <StyledHeader>
      <StyledLocation>{location}</StyledLocation>
      <StyledInputContainer
        isOpen={isOpen}
        onClick={() => {
          setIsOpen(true);
        }}
      >
        <Input isOpen={isOpen} />
      </StyledInputContainer>
    </StyledHeader>
  );
};
